const normalizeDomain = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .split("/")[0]
    .split(".")[0];

  return ["", "null", "undefined"].includes(normalized) ? "" : normalized;
};

export const getPublicStoreOrigin = (domain) => {
  const isWebOrigin =
    typeof window !== "undefined" &&
    ["http:", "https:"].includes(window.location.protocol) &&
    window.location.host;

  if (isWebOrigin) {
    return `${window.location.protocol}//${window.location.host}`;
  }

  const storeDomain = normalizeDomain(
    domain ||
      (typeof localStorage !== "undefined"
        ? localStorage.getItem("vmass_store_domain")
        : ""),
  );

  return storeDomain ? `https://${storeDomain}.vmass.vn` : "";
};

export const buildPublicMenuUrl = (menuHash, domain) => {
  const normalizedHash = String(menuHash || "").trim();
  const origin = getPublicStoreOrigin(domain);

  if (!origin || !normalizedHash) return "";
  return `${origin}/menu/${normalizedHash}`;
};

